import React from 'react';
import classnames from 'classnames';
import { scaleToSize } from '../_helpers';
import MediaService from '../../utils/DeviationMediaService';
import BlurredBackground from '../Full/_partials/BlurredBackground';
import hiddenStyles from './Hidden.scss';
var HiddenLayout = function (_a) {
    var icon = _a.icon, compact = _a.compact, _b = _a.showBackground, showBackground = _b === void 0 ? true : _b, strict = _a.strict, title = _a.title, text = _a.text, className = _a.className, button = _a.button, secondaryButton = _a.secondaryButton, deviation = _a.deviation, width = _a.width, height = _a.height;
    var background = MediaService.getSmallestThumb(deviation);
    var fullImage = MediaService.getFullviewForSize(deviation, width, height);
    var childBoxSize = fullImage
        ? scaleToSize(fullImage, { width: width, height: height })
        : { width: width, height: height };
    return (React.createElement("div", { style: {
            width: width,
            height: height,
        }, className: classnames(className, hiddenStyles['root'], compact && hiddenStyles['compact'], strict && hiddenStyles['strict']) },
        React.createElement("div", { style: childBoxSize, className: hiddenStyles['blocked-placeholder'] },
            showBackground && background && (React.createElement(BlurredBackground, { imageUrl: background.src, clientSideBlur: true })),
            React.createElement("div", { className: hiddenStyles['blocked-wrap'] },
                React.createElement("div", { className: hiddenStyles['blocked-icon'] }, icon),
                title && (React.createElement("div", { className: hiddenStyles['blocked-title'] }, title)),
                Array.isArray(text)
                    ? text.map(function (node, idx) {
                        return node && (React.createElement("div", { key: idx, className: title
                                ? hiddenStyles['blocked-text']
                                : hiddenStyles['blocked-text-large'] }, node));
                    })
                    : text && (React.createElement("div", { className: title
                            ? hiddenStyles['blocked-text']
                            : hiddenStyles['blocked-text-large'] }, text)),
                button,
                secondaryButton))));
};
HiddenLayout.displayName = 'HiddenLayout';
export default HiddenLayout;
//# sourceMappingURL=HiddenLayout.js.map